import React from 'react';
import {bool, func, node, string} from 'prop-types';
import styles from './ButtonCard.scss';
import classNames from 'classnames';

const ButtonCard = ({children: title, href, backgroundSrc, className, openNewTab, onClick}) => {
  const cardStyle = backgroundSrc ? {
    backgroundImage: `url(${backgroundSrc})`,
  } : {};
  const cardClass = classNames(styles.buttonCard, className);

  return (
    <a
      className={cardClass}
      style={cardStyle} href={href}
      target={openNewTab ? '_blank' : undefined }
      rel={openNewTab ? 'noreferrer noopener' : undefined}
      onClick={onClick}
    >
      <span className={styles.title}>{title}</span>
      <div className={styles.overlay}></div>
    </a>
  );
};

ButtonCard.propTypes = {
  children: node,
  href: string.isRequired,
  backgroundSrc: string,
  className: string,
  openNewTab: bool,
  onClick: func,
};

ButtonCard.defaultProps = {
  backgroundSrc: '',
  className: '',
  openNewTab: false,
  onClick: () => null,
};

ButtonCard.displayName = 'ButtonCard';

export default ButtonCard;
